var map = {
	"./10_nuts.png": 2477,
	"./1drink_12beer.png": 2478,
	"./1serving_8ounces.png": 2479,
	"./1serving_8ounces2.png": 2480,
	"./1serving_8ounces3.png": 2481,
	"./1serving_8ounces4.png": 2482,
	"./1serving_8ounces5.png": 2483,
	"./8ounces_1glass.png": 2484,
	"./can_1.png": 2485,
	"./can_2.png": 2486,
	"./can_3.png": 2487,
	"./cup.png": 2488,
	"./dried_serving_1/4cup.png": 2489,
	"./dried_serving_1:4cup.png": 2490,
	"./fresh_serving_1cup.png": 2491,
	"./glass_1.png": 2492,
	"./glass_2.png": 2493,
	"./golfball.png": 2494,
	"./halfthumb.png": 2495,
	"./hand_1.png": 2496,
	"./hand_2.png": 2497,
	"./hand_3.png": 2498,
	"./hand_4.png": 2499,
	"./hand_5.png": 2500,
	"./how.png": 860,
	"./serving_1/2cup.png": 2501,
	"./serving_1:2cup.png": 2502,
	"./serving_1tbsp.png": 2503,
	"./serving_3/4ounces.png": 2504,
	"./serving_3:4ounces.png": 2505,
	"./thumbx2.png": 2506,
	"./usda.png": 2507,
	"./vegetables_1cup.png": 2508,
	"./what.png": 858,
	"./wholethumb.png": 2509,
	"./why.png": 859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2476;